(() => {
    // Use handle for detection — robust across variant ID changes.
    const GIFT_PRODUCT_HANDLE = 'gift-wrap';

    const isGiftWrap = (item) => item.handle === GIFT_PRODUCT_HANDLE;

    async function getCart() {
        const res = await fetch("/cart.js", {
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        return res.json();
    }

    async function getGiftVariantId() {
        try {
            const res  = await fetch('/products/' + GIFT_PRODUCT_HANDLE + '.js');
            const prod = await res.json();
            return prod.variants[0].id;
        } catch (e) {
            console.error('[Kymee] gift variant fetch error:', e);
            return null;
        }
    }

    async function addGiftWrap() {
        const variantId = await getGiftVariantId();
        if (!variantId) return;
        await fetch("/cart/add.js", {
            method:  "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
            body:    JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
    }

    async function removeGiftWrap(key) {
        return fetch("/cart/change.js", {
            method:  "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
            body:    JSON.stringify({ id: key, quantity: 0 }),
        });
    }

    document.addEventListener(
        "change",
        async (e) => {
            const checkbox = e.target.closest("[data-gift-wrap-checkbox]");
            if (!checkbox) return;

            const checked = checkbox.checked;
            e.stopPropagation();
            e.stopImmediatePropagation();
            checkbox.disabled = true;

            try {
                const cart = await getCart();
                const wrap = cart.items.find(isGiftWrap);

                if (checked && !wrap) {
                    // Gift wrap not in cart — add it, then refresh
                    await addGiftWrap();
                    const drawer = document.querySelector("kymee-cart-drawer");
                    drawer?.refresh?.({ openIfClosed: true });
                } else if (checked && wrap) {
                    // Gift wrap already in cart — select its line item checkbox so selection state syncs
                    const drawer = document.querySelector("kymee-cart-drawer");
                    const gwRow = drawer?.querySelector(`[data-key="${wrap.key}"]`);
                    const gwItemCb = gwRow?.querySelector("[data-item-check]");
                    if (gwItemCb && !gwItemCb.checked) {
                        gwItemCb.checked = true;
                        // Mark this event so it doesn't trigger other handlers
                        const evt = new Event("change", { bubbles: false });
                        evt._fromGiftWrap = true;
                        gwItemCb.dispatchEvent(evt);
                    }
                } else if (!checked && wrap) {
                    // Pill unchecked — do NOT remove from cart; just unselect the line item
                    const drawer = document.querySelector("kymee-cart-drawer");
                    const gwRow = drawer?.querySelector(`[data-key="${wrap.key}"]`);
                    const gwItemCb = gwRow?.querySelector("[data-item-check]");
                    if (gwItemCb && gwItemCb.checked) {
                        gwItemCb.checked = false;
                        // Mark this event so it doesn't trigger other handlers
                        const evt = new Event("change", { bubbles: false });
                        evt._fromGiftWrap = true;
                        gwItemCb.dispatchEvent(evt);
                    }
                }
                // !checked && !wrap → nothing to do

            } catch (err) {
                checkbox.checked = !checked; // rollback on error
            } finally {
                checkbox.disabled = false;
            }
        },
        true
    );

    /* ── Gift wrap checkbox state sync ── */
    function syncGiftWrapCheckbox() {
        const drawer = document.querySelector("kymee-cart-drawer");
        if (!drawer) return;

        const checkbox = drawer.querySelector("[data-gift-wrap-checkbox]");
        const wrapper  = checkbox?.closest("[data-gift-wrap-wrapper]");
        if (!checkbox || !wrapper) return;

        fetch("/cart.js", { credentials: "same-origin" })
            .then(r => r.json())
            .then(cart => {
                const hasGiftWrap = cart.items.some(isGiftWrap);
                checkbox.checked = hasGiftWrap;
                wrapper.classList.toggle("is-active", hasGiftWrap);
                checkbox.setAttribute("aria-checked", hasGiftWrap ? "true" : "false");
            });
    }

    document.addEventListener("DOMContentLoaded", () => {
        requestAnimationFrame(syncGiftWrapCheckbox);
    });

})();
